import { useEffect, useState } from "react";
import { ArrowRight, X } from "lucide-react";
import { buildSignupUrl } from "@/lib/constants";
import { trackEvent } from "@/lib/analytics";
// RESONATE_ANALYTICS_INSTRUMENTED
// RESONATE_PERF_V3 — framer-motion AnimatePresence swapped for a CSS
// translate/opacity transition; keeps the bar out of the critical JS bundle.

export const StickyBar = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? y / max : 0;
      setShow(pct > 0.25 && pct < 0.92);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const visible = show && !dismissed;

  return (
    <div
      data-testid="sticky-bar"
      aria-hidden={!visible}
      style={{
        transform: visible ? "translateY(0)" : "translateY(120%)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transition: "transform 0.45s cubic-bezier(0.22,1,0.36,1), opacity 0.45s cubic-bezier(0.22,1,0.36,1)",
      }}
      className="fixed bottom-4 left-[12.5%] right-[12.5%] w-[75%] z-40 bg-[#111827] text-white rounded-2xl shadow-[0_30px_60px_-20px_rgba(0,0,0,0.4)] hidden md:flex items-center justify-between gap-4 px-5 py-3"
    >
      <div className="flex flex-col">
        <span className="text-[13px] font-semibold">LinkedIn posts in your voice, from your real work.</span>
        <span className="text-[11px] text-white/70">14 days free · 30-day money-back guarantee · cancel in two clicks</span>
      </div>
      <div className="flex items-center gap-2">
        <button
          data-testid="sticky-dismiss"
          onClick={() => { trackEvent('sticky_bar_dismiss'); setDismissed(true); }}
          className="text-white/45 hover:text-white/80 transition-colors p-1"
          aria-label="Dismiss"
          tabIndex={visible ? 0 : -1}
        >
          <X className="w-4 h-4" />
        </button>
        <a
          href={buildSignupUrl('sticky_bar')} onClick={() => trackEvent('cta_click', { location: 'sticky_bar' })}
          data-testid="sticky-cta"
          className="inline-flex items-center gap-1.5 bg-white text-[#111827] hover:bg-[#FAFAFF] px-4 py-2 rounded-lg text-[12.5px] font-medium transition-colors"
          tabIndex={visible ? 0 : -1}
        >
          Start for free <ArrowRight className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
  );
};
